import {calculateDayDiff} from './timeUtils';
import moment from 'moment';
import {PAYMENT_TYPES, PURCHASE_TYPES} from '../constants/purchase.constants';
import commaNumber from 'comma-number';

export function getRefundAmount(entitlement, purchase) {
  if (isCancellableEntitlement(entitlement, purchase)) {
    return commaNumber(
      _calculateRefundableAmountBeforeCharge(
        entitlement.totalTimeCredit,
        entitlement.remainingTimeCredit,
        purchase.payment.price
      )
    );
  }
  if (isRefundableWithNoRefundCharge(entitlement, purchase)) {
    return commaNumber(
      _calculateRefundableAmountBeforeCharge(
        entitlement.totalTimeCredit,
        entitlement.remainingTimeCredit,
        purchase.payment.price
      )
    );
  }
  if (isRefundableEntitlement(entitlement))
    return commaNumber(
      _calculateRefundableAmountAfterCharge(
        entitlement.totalTimeCredit,
        entitlement.remainingTimeCredit,
        purchase.payment.price
      )
    );
}

export function isRefundableEntitlement(entitlement) {
  return entitlement.type == PURCHASE_TYPES.PAID && entitlement.remainingTimeCredit > 0;
}

export function isCancellableEntitlement(entitlement, purchase) {
  if (entitlement.totalTimeCredit != entitlement.remainingTimeCredit) {
    return false;
  }
  if (!purchase.payment) {
    return false;
  }
  let paymentType = purchase.payment.paymentType;
  if (paymentType === PAYMENT_TYPES.VIRTUAL_ACCOUNT) {
    return false;
  }
  let dayDiffSincePurchase = calculateDayDiff(moment.utc(purchase.created), moment());
  if (paymentType === PAYMENT_TYPES.ACCOUNT_TRANSFER && dayDiffSincePurchase > 0) {
    return false;
  }
  if (dayDiffSincePurchase > 7) {
    return false;
  }
  return true;
}

export function isRefundableWithNoRefundCharge(entitlement, purchase, currentDate = moment()) {
  let dayDiffSincePurchase = calculateDayDiff(moment.utc(purchase.created), currentDate);
  if (
    isRefundableEntitlement(entitlement) &&
    dayDiffSincePurchase <= 7 &&
    entitlement.totalTimeCredit == entitlement.remainingTimeCredit
  ) {
    return true;
  }
}

function _calculateRefundableAmountAfterCharge(totalTimeCredit, remainingTimeCredit, paidPrice) {
  let refundAmountBeforeCharge = _calculateRefundableAmountBeforeCharge(
    totalTimeCredit,
    remainingTimeCredit,
    paidPrice
  );
  return refundAmountBeforeCharge - _calculateRefundCharge(refundAmountBeforeCharge);
}

function _calculateRefundableAmountBeforeCharge(totalTimeCredit, remainingTimeCredit, paidPrice) {
  return Math.round((paidPrice * remainingTimeCredit) / totalTimeCredit);
}

function _calculateRefundCharge(refundableAmountBeforeCharge) {
  return Math.round(refundableAmountBeforeCharge * 0.1);
}

export function refundFees(price, totalTimeCredit, remainingTimeCredit) {
  return _calculateRefundCharge(_calculateRefundableAmountBeforeCharge(totalTimeCredit, remainingTimeCredit, price));
}
